import CapTracLogo from '@/components/CapTracLogo';
import '@/styles/loginStyles.scss';
import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import * as Sentry from '@sentry/react';

const RequestReset = () => {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    // Remove sentry-feedback div if they exist when the component mounts
    useEffect(() => {
        const sentryFeedbackDiv = document.getElementById('sentry-feedback');
        if (sentryFeedbackDiv && sentryFeedbackDiv.parentNode) {
            sentryFeedbackDiv.parentNode.removeChild(sentryFeedbackDiv);
        }
    }, []);

    const handleReset = async (e) => {
        e.preventDefault();
        if (!email) {
            toast.error('Email address is required');
            return;
        }

        try {
            setIsLoading(true);

            const response = await fetch('/api/User/request-reset', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email })
            });

            if (!response.ok) {
                toast.error('Error sending reset link. Please try again.');
                return;
            }

            const data = await response.json();

            if (data.success) {
                toast.success('Reset link sent. Please check your email address');
                setEmail('');
            } else {
                toast.error('Error sending reset link. Please try again.');
            }
        } catch (e) {
            Sentry.captureException(e);
            console.error(e)
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <div id="login-main-container">
            <div id="login-container">
                <div id="login-image">
                    <CapTracLogo scale={0.5} capColor="var(--primary-color)" hexagonColor="var(--primary-color)" />
                </div>
                <h2>Please enter your email address</h2>
                <div id="login-creds">
                    <div id="login-username" className="login-input-container">
                        <input type="email" placeholder=" " id="reset-input" value={email} onChange={e => setEmail(e.target.value)} />
                        <label className="login-label" htmlFor="reset-input">Email Address</label>
                    </div>
                </div>
                <button id="login-button" type="submit" disabled={isLoading} onClick={handleReset}>
                    {isLoading ? 'Sending email...' : 'Send Reset Link'}
                </button>
                <Link to="/" >Back to Sign in</Link>
            </div>
        </div>
    );
};

export default RequestReset;